import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { AccessRights } from "lib/constants/accessRights";
import CounterfeitReportDetailComponent from "./counterfeit-report-detail.page";
import LoadingComponent from "components/loading";
import { canAccess } from "../../../profile/redux/selector/profile.selector";

export default function CounterfeitReportDetailContainer() {
  const history = useHistory();
  const hasCounterfeitReportViewAccessRight = useSelector((state) =>
    canAccess(state, AccessRights.Counterfeit.LIST_READ)
  );
  const lang = useSelector((state) => state.constant.languages);
  useEffect(() => {
    if (!hasCounterfeitReportViewAccessRight) {
      history.push("/admin/dashboard");
    }
  }, [history, hasCounterfeitReportViewAccessRight]);

  if (!hasCounterfeitReportViewAccessRight) return <LoadingComponent />;

  return <CounterfeitReportDetailComponent lang={lang} />;
}
